// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"88d91c90","459":"c56fd5b8"}[chunkId] + ".chunk.css";
};